<template>
  <Modal v-if="modals.fabled && offered.length" @close="toggleModal('fabled')">
    <h3>Bring a Fabled character into the game</h3>
    <ul class="fabled-choices">
      <li v-for="role in offered" :key="role.id" @click="addFabled(role)">
        <Token :role="role" />
      </li>
    </ul>
  </Modal>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Modal from "./Modal";
import Token from "../Token";

export default {
  components: { Token, Modal },
  computed: {
    ...mapState(["modals"]),
    /** Every Fabled on offer that the game doesn't already have. */
    offered() {
      const inPlay = this.$store.state.players.fabled.map((f) => f.id);
      return Array.from(this.$store.state.fabled.values()).filter(
        (role) => !inPlay.includes(role.id),
      );
    },
  },
  methods: {
    addFabled(role) {
      this.$store.commit("players/setFabled", { fabled: role });
      this.toggleModal("fabled");
    },
    ...mapMutations(["toggleModal"]),
  },
};
</script>

<style scoped lang="scss">
// bigger than the character picker's coins — there are only ever a handful
.fabled-choices li {
  width: 12vw;
  height: 12vw;
  margin: 0.6vw;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 220ms ease;

  &:hover {
    transform: scale(1.25);
    z-index: 3;
  }
}
</style>
